import React from "react";
import {useTranslation} from "react-i18next";
import Grid from "@material-ui/core/Grid";
import {A} from 'hookrouter';
import Button from "@material-ui/core/Button";

export function Navigation(props) {

    const {parentId, parentName} = props;

    const {t} = useTranslation('roles');

    return (
        <Grid container direction="column">
            <Grid item xs={12}>
                <A href={"/admin/roles/" + parentId + "/grants/role-name=" + parentName.toUpperCase()}>
                    <Button variant="contained" color="primary" size="small">{t('grants')}</Button>
                </A>
            </Grid>
        </Grid>
    );
}